import styled from '@emotion/styled';

const Button = styled.input`
  background-color: transparent;
  border: solid 3px white;
  color: #fff;
  font-size: 18px;
  border-radius: 7px;
  display: block;
  padding: 0.5em;
  margin: auto;
  max-width: 50%;
  text-align: center;
  min-width: 250px;
  margin-bottom: 20px;
  font-family: inherit;
  font-weight: inherit;
  cursor: pointer;
`;

export default Button;
